/**
 * Accordion variation add-on for the Travel Size Bundler.
 *
 * The shared builder logic lives in custom-travel-size-bundle-builder.js and is
 * reused unchanged. This script only handles the accordion-specific chrome: it
 * shows a "how many selected" badge on each category header so selections made
 * inside a collapsed panel stay visible. Expand/collapse is native <details>.
 *
 * It is fully decoupled from the shared script — it observes the selected class
 * on the product cards rather than hooking into the builder's internals.
 */

document.addEventListener('DOMContentLoaded', () => {
  const root = document.querySelector('[data-bb-root]');
  if (!(root instanceof HTMLElement)) {
    return;
  }

  const accordions = Array.from(root.querySelectorAll('[data-bb-acc]'));
  if (!accordions.length) {
    return;
  }

  const cards = Array.from(root.querySelectorAll('[data-bb-product-card]'));
  if (!cards.length) {
    return;
  }

  function updateCounts() {
    accordions.forEach((accordion) => {
      const badge = accordion.querySelector('[data-bb-acc-count]');
      if (!(badge instanceof HTMLElement)) {
        return;
      }
      const selected = accordion.querySelectorAll('[data-bb-product-card].bb-prod-card--selected').length;
      // Always show the counter (defaults to 0) so it reads clearly as a product counter.
      badge.textContent = String(selected);
      accordion.classList.toggle('bb-acc--has-selected', selected > 0);
    });
  }

  const observer = new MutationObserver(() => updateCounts());
  cards.forEach((card) => {
    observer.observe(card, { attributes: true, attributeFilter: ['class', 'aria-checked'] });
  });

  updateCounts();
});
